<template>
    <div class="stock" v-if="product?.delivery_time">
        <span :class="[`indicator-${product?.delivery_time?.id}`, 'indicator']">&bullet;</span>
        <span class="text">{{ product?.delivery_time?.translated?.name }}</span>
    </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        product: {
            type: Object,
            default() {
                return null;
            }
        },
    },
});
</script>
<style scoped>
.stock {
    display: flex;
    gap: 6px;
    font-size: 12px;
}

.indicator {
    transform: scale(1.2);
}

.indicator-4a26ed934de94942865763e63a2e6efa {
    color: #ff9200;;
}

.indicator-5ae66ca4e2124856b52e872650f1de21 {
    color: green;
}
</style>
